import { ToolbarProps, SaveButton, DeleteButton, MutationMode } from 'react-admin';
import { Toolbar, Box } from '@mui/material';
import { AuditButton } from './AuditButton';
import { UseMutationOptions } from '@tanstack/react-query';

interface EditToolbarProps extends ToolbarProps {
  showDeleteButton?: boolean;
  showAuditButton?: boolean;
  showSaveButton?: boolean;
  deleteMutationMode?: MutationMode;
  deleteMutationOptions?: UseMutationOptions<unknown, unknown, unknown>;
}

export const EditToolbar = ({
  showDeleteButton = true,
  showAuditButton = true,
  showSaveButton = true,
  deleteMutationMode = 'pessimistic',
  deleteMutationOptions,
  ...props
}: EditToolbarProps) => (
  <Toolbar {...props} sx={{ display: 'flex', justifyContent: 'space-between' }}>
    {showSaveButton && <SaveButton />}
    <Box sx={{ display: 'flex', gap: 1 }}>
      {showAuditButton && <AuditButton />}
      {showDeleteButton && <DeleteButton mutationMode={deleteMutationMode} mutationOptions={deleteMutationOptions} />}
    </Box>
  </Toolbar>
);
